<template>
  <div>
    <span class="common-text-medium">{{ text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";

.common-text-medium {
  font-size: 18px;
  font-family: $aisea-font-family;
  font-weight: 600;
  color: $common-text-dark-gray;
}
</style>